export default __webpack_public_path__ + "f4ccceacd3f713abd75c92d0d94758d2.png";